<div class="card" *ngIf="dataSource">
  <div class="quote-list-card fuse-card auto-width" style="overflow: hidden">
    <div fxLayout="row" fxLayout.lt-sm="column" class="p-12" fxLayoutAlign="space-between center" fxLayoutGap="15px">
      <div fxFlex fxLayoutAlign="start center">
        <div class="dashboard-card-title">Pedidos de cotação</div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <button *ngIf="defaultShareLink?.pageLink" class="btn btn-copy-link" fxLayout="row" fxLayoutAlign="center center" (click)="copyShareLink()">
          <mat-icon class="s-16">{{ copiedLink ? 'check' : 'content_copy' }}</mat-icon>
          <span class="pl-4 btn-copy-link-text" fxHide.xs>{{ copiedLink ? 'Copiado!' : 'Copiar link' }}</span>
        </button>
        <button class="btn btn-blue" fxLayout="row" fxLayoutAlign="center center" (click)="openSettings()">
          <mat-icon class="s-16">settings</mat-icon>
          <span class="pl-4">Configurações</span>
        </button>
      </div>
    </div>

    <div [ngClass]="{ 'hide-table': !showTable }">
      <app-table #quotesList [dataSource]="dataSource" [displayedColumns]="displayedColumns" 
        [pageSizeOptions]="[5, 10, 50]" [pageSize]="pageSize" 
        (onTableUpdate)="onTableUpdate($event)" (onSelectedRow)="onSelectedRow($event)">

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let quote">
            <div fxLayout="column" fxLayoutAlign="start start">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div class="quote-pending-alert" *ngIf="quote.pendingAlert" [matTooltip]="quote.pendingAlertText || ''">
                    <mat-icon class="icon-timer">timer</mat-icon>
                  </div>
                  <span class="quote-title">{{ quote.name }}</span>
                </div>
                <span *ngIf="quote.origin" class="text-boxed origin-badge" fxHide fxShow.gt-xs matTooltip="Origem">
                  <mat-icon class="s-12 mr-4">link</mat-icon>{{ quote.origin }}
                </span>
                <span *ngIf="!quote.origin" class="text-boxed origin-badge default" fxHide fxShow.gt-xs matTooltip="Origem">
                  <mat-icon class="s-12 mr-4">link</mat-icon>Padrão
                </span>
              </div>
              <span class="quote-subtitle">
                <span *ngIf="quote.phone">{{ quote.phone }}</span>
                <span *ngIf="quote.phone && (quote.city || quote.state)"> | </span>
                <span *ngIf="quote.city || quote.state">{{ quote.city }}<span *ngIf="quote.state">-{{ quote.state }}</span></span>
              </span>
              <span class="quote-subtitle" *ngIf="quote.createdAt">
                Criado em {{ quote.createdAt | date: "dd/MM/yyyy HH:mm" }}
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="requested_at">
          <th mat-header-cell *matHeaderCellDef class="text-center" fxHide fxShow.gt-sm>Solicitado</th>
          <td mat-cell *matCellDef="let quote" fxHide fxShow.gt-sm>
            <div fxLayout="row" fxLayoutAlign="center center">
              <div class="quote-subtitle" style="white-space: nowrap;">
                {{ quote.requisitadaEm }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let quote" [ngClass.lt-lg]="'pr-8'">
            <div class="py-8">
              <button class="btn-proposal-actions" mat-icon-button [matMenuTriggerFor]="quoteMenuComponent.moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                <mat-icon class="secondary-text">more_vert</mat-icon>
              </button>
              <app-quote-actions [quote]="quote" #quoteMenuComponent (onQuoteChanged)="quotesList.loadTable()"></app-quote-actions>
            </div>
          </td>
        </ng-container>

        <ng-template #emptyTemplate>
          <div class="empty-view">
            <div class="empty-view-title">Nenhuma solicitação de orçamento</div>
            <div class="empty-view-subtitle">
              Quando clientes solicitarem orçamentos pela sua página, eles aparecerão aqui.
            </div>
          </div>
        </ng-template>
      </app-table>
    </div>
  </div>
</div>
